module.exports = __webpack_public_path__ + "media/npc_dota_hero_tiny.b12fd9bd.webm";